import React from "react";
import { Helmet } from "react-helmet";
import ReactWhatsapp from "react-whatsapp";
import Common from "../Container/Common";

function Installation() {
  return (
    <div>
      <Helmet>
        <title>
          Reliable Fire Safety Installation|Trust Experts to Keep You Safe
        </title>

        <meta
          name="description"
          content="  Wet and dry riser systems, Courtyard hydrant systems, Auto sprinkler systems, Pump house of auto/manual start types, and Gaseous fire suppression systems."
        />

        <meta
          name="keyword"
          content="fire and sprinkler inspection, fire sprinkler inspections, fire extinguishers, sprinklers systems, smoke detection, extinguishers, fire alarms system, type a fire extinguisher, fire detection system, sprinkler fire, fire sprinkler systems, fire alarm, fire suppression systems, fire alarm panel, fire sensor, fire panel, fire fighting companies, installation of fire alarm, fire alarm, and detection systems



"
        />

        <meta
          name="robots"
          content="index, follow, max-image-preview:large, max-snippet:1, max-video-preview:1"
        />
        <link
          rel="canonical"
          href="https://www.therapidhire.com/installation"
          data-react-helmet="true"
        ></link>
        <meta
          name="fb:app_id"
          content="1369882117133030"
          data-react-helmet="true"
        />
        <meta
          property="og:url"
          content="https://www.therapidhire.com/installation"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Reliable Fire Safety Installation|Trust Experts to Keep You Safe"
        />
        <meta
          property="og:description"
          content="Wet and dry riser systems, Courtyard hydrant systems, Auto sprinkler systems, Pump house of auto/manual start types, and Gaseous fire suppression systems."
        />
        <meta
          property="og:image"
          content="https://www.therapidhire.com/images/Firesafety3.jpg"
        />
        <meta property="og:image:type" content="image/jpg" />
        <meta property="og:image:width" content="600" />
        <meta property="og:image:height" content="315" />
        <meta property="og:image:alt" content="fire safety" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@therapidhire_" />
        <meta
          property="twitter:url"
          content="https://www.therapidhire.com/installation"
        />
        <meta
          name="twitter:title"
          content="Reliable Fire Safety Installation|Trust Experts to Keep You Safe"
        />
        <meta
          name="twitter:description"
          content="Wet and dry riser systems, Courtyard hydrant systems, Auto sprinkler systems, Pump house of auto/manual start types, and Gaseous fire suppression systems."
        />
        <meta
          name="twitter:image"
          content="https://www.therapidhire.com/images/Firesafety3.jpg"
        />
      </Helmet>
      <div
        id="rs-slider"
        className="rs-slider slider3 rs-slider-style3"
        style={{ position: "relative", overflow: "hidden" }}
      >
        <div className="bend niceties">
          <img src="images/Firesafety3.jpg" alt="Firesafety" title="" />
        </div>
      </div>
      <div className="container">
        <div className=" py-5">
          <h2
            className="h3 block-title text-center py-3 font-weight-bold"
            style={{
              fontWeight: "600",
              backgroundColor: "#00003c",
              color: "white",
            }}
          >
            FIRE PROTECTION SYSTEMS
          </h2>
          <p className="text-center">
            <strong className="text-center fs-4" style={{ fontWeight: "400" }}>
              Wet and dry riser systems, Courtyard hydrant systems, Auto
              sprinkler systems, Pump house of auto/manual start types, Gaseous
              fire suppression systems
            </strong>
          </p>

          <div className="container">
            <div className="row">
              <div className="cardimges col-md-4 mt-3 col-lg-3">
                <img
                  className=""
                  src="images/Fire1.jpg"
                  class="img-fluid "
                  alt="Fire1"
                />
              </div>
              <div className="cardimges col-md-4 mt-3 col-lg-3">
                <img src="images/Fire2.jpg" className="img-fluid" alt="Fire2" />
              </div>
              <div className="cardimges col-md-4 mt-3 col-lg-3">
                <img src="images/Fire3.png" className="img-fluid" alt="Fire3" />
              </div>
              <div className="cardimges col-md-4 mt-3 col-lg-3">
                <img src="images/Fire4.png" className="img-fluid" alt="Fire4" />
              </div>
            </div>
          </div>
        </div>

        <div className="">
          <h2
            className="h3 block-title text-center py-3 font-weight-bold"
            style={{
              fontWeight: "600",
              backgroundColor: "#00003c",
              color: "white",
            }}
          >
            FIRE DETECTION AND ALARM SYSTEMS
          </h2>
          <p className="text-center">
            <strong className="text-center fs-4" style={{ fontWeight: "400" }}>
              Conventional type fire detection and alarm systems, Addressable
              type fire detection and alarm systems, Aspiration / VESDA systems,
              Public Address and digital voice evacuation systems
            </strong>
          </p>

          <div className="container py-5">
            <div className="row">
              <div className="col-md-4 mt-3 col-lg-3">
                <img
                  src="images/detection1.jpg"
                  className="img-fluid cardimges"
                  alt="detection1"
                />
              </div>
              <div className="col-md-4 mt-3 col-lg-3">
                <img
                  src="images/detection2.jpg"
                  className="img-fluid cardimges"
                  alt="detection2"
                />
              </div>
              <div class="col-md-4 mt-3 col-lg-3">
                <img
                  src="images/detection6.png"
                  className="img-fluid cardimges"
                  alt="detection3"
                />
              </div>
              <div class="col-md-4 mt-3 col-lg-3">
                <img
                  src="images/detection4.jpg"
                  className="img-fluid cardimges"
                  alt="detection4"
                />
              </div>
              <div class="col-md-4 mt-3 col-lg-3">
                <img
                  src="images/detection8.png"
                  className="img-fluid cardimges"
                  alt="detection5"
                />
              </div>
              <div class="col-md-4 mt-3 col-lg-3">
                <img
                  src="images/detection3.jpg"
                  className="img-fluid cardimges "
                  alt="detection6"
                />
              </div>
              <div className="col-md-4 mt-3 col-lg-3">
                <img
                  src="images/detection7.png"
                  className="img-fluid cardimges"
                  alt="detection7"
                />
              </div>
              <div className="col-md-4 mt-3 col-lg-3">
                <img
                  src="images/detection5.png"
                  class="img-fluid cardimges"
                  alt="detection8"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="floating_btn">
        <a target="_blank" href="https://wa.me/">
          <div className="contact_icon">
            <ReactWhatsapp
              number="+91-9907657026"
              message="Hello, May I Help You !"
              className="whatsappbuttn"
            >
              {" "}
              <i className="fa fa-whatsapp"></i>
            </ReactWhatsapp>
          </div>
        </a>
        <p className="text_icon">Chat with us</p>
      </div>
    </div>
  );
}

export default Installation;
